<ngb-alert type="info" (closed)="closeBanner()" *ngIf="showBanner">
    If you experience an emergency issue with your advent calendar campaign please contact our support at +41 79 226 46 59.
</ngb-alert>